import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useContext } from 'react';
import classnames from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import s from './Separator.scss';
export var Breakpoint;
(function(Breakpoint) {
    Breakpoint[Breakpoint["Both"] = 0] = "Both";
    Breakpoint[Breakpoint["Desktop"] = 1] = "Desktop";
    Breakpoint[Breakpoint["Mobile"] = 2] = "Mobile";
})(Breakpoint || (Breakpoint = {}));
const Separator = (_param)=>{
    var { className, forBreakpoint = 0 } = _param, rest = _object_without_properties(_param, [
        "className",
        "forBreakpoint"
    ]);
    const isMobile = useContext(MobileContext);
    return /*#__PURE__*/ React.createElement("hr", _object_spread({
        className: classnames(className, s['separator'], forBreakpoint === 1 && isMobile && s['hidden'], forBreakpoint === 2 && !isMobile && s['hidden'])
    }, rest));
};
Separator.displayName = 'Separator';
export default Separator;

//# sourceMappingURL=Separator.js.map